/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Tame_Rat_PushInputs */

const en_ivory_tame_rat_push = /** @type {(inputs: Ivory_Tame_Rat_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow login`)
};

const de_ivory_tame_rat_push = /** @type {(inputs: Ivory_Tame_Rat_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login erlauben`)
};

/**
* | output |
* | --- |
* | "Allow login" |
*
* @param {Ivory_Tame_Rat_PushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_tame_rat_push = /** @type {((inputs?: Ivory_Tame_Rat_PushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Tame_Rat_PushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_tame_rat_push(inputs)
	return de_ivory_tame_rat_push(inputs)
});